"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useOpenCategory = isOpen => {
  const [openCategory, setOpenCategory] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    if (!isOpen && openCategory !== null) {
      setOpenCategory(null);
    }
  }, [isOpen]);
  const toggleCategory = newOpenCategory => {
    if (newOpenCategory === openCategory) {
      setOpenCategory(null);
    } else {
      setOpenCategory(newOpenCategory);
    }
  };
  return {
    openCategory,
    toggleCategory
  };
};
var _default = useOpenCategory;
exports.default = _default;